import React from 'react'
import Menu from 'antd/lib/menu'
import Dropdown from 'antd/lib/dropdown'

const selectedSortLabel = (selected, strings) => {
  const key = `sort_by_${selected}`
  return key in strings ? <b>{strings[key]}</b> : ''
}

const handleSort = (e, onSort, val) => {
  e.preventDefault();
  onSort(val)
}

const renderSortMenu = (items, onSort) => {
  const menuItems = items.map((item, idx) => {
    return (
      <Menu.Item key={idx}>
        <a onClick={e => handleSort(e, onSort, item.value)}>{item.label}</a>
      </Menu.Item>
    )
  })
  return ( 
    <Menu>
      {menuItems}
    </Menu>
  )
}

const Sort = (props) => {
  const items = [
    {
      label: props.strings.sort_by_availableDate,
      value: 'availableDate',
    },
    {
      label: props.strings.sort_by_priceHighest,
      value: 'priceHighest',
    },
    {
      label: props.strings.sort_by_priceLowest,
      value: 'priceLowest',
    },
    {
      label: props.strings.sort_by_latest,
      value: 'latest',
    }
  ]
  const allItems = items.concat(props.extraSortOptions)
  return (
    <div className="gw-search__sort-control">
      <Dropdown overlay={renderSortMenu(allItems, props.onSort)} trigger={['click']}>
        <div className="gw-search__sort-control-trigger">
          {props.strings.sort_by} {selectedSortLabel(props.sortBy, props.strings)}
        </div>
      </Dropdown>
    </div>
  )
}

export default Sort


// WEBPACK FOOTER //
// ./src/components/search/Sort.js